<div class="modal-header">
    <h1 mat-dialog-title>{{title}}</h1>
</div>

<div *ngIf="action !== 'delete'; else deleteTemplate" mat-dialog-content>
    <form [formGroup]="formData" class="modal-form">
              
            <div *ngIf="(data.action === 'add' && nameTable === 'crawling-web')">
                <!-- Banner informativo -->
                 <div class="info-banner">
                    <mat-icon>info</mat-icon>
                    <span>Il nuovo job verrà inserito nella tabella dei <strong>Draft Jobs</strong> in attesa di schedulazione.</span>
                 </div>
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Id Crawl</mat-label>
                    <input matInput formControlName="crawlId"/>
                    <mat-error *ngIf="formData.get('crawlId')?.hasError('required') && formData.get('crawlId')?.touched">
                        Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>
                
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="name"/>
                    <mat-error *ngIf="formData.get('name')?.hasError('pattern')">
                        Non sono ammessi spazi e caratteri speciali.
                    </mat-error>
                    <mat-error *ngIf="formData.get('name')?.hasError('required') && formData.get('name')?.touched">
                        Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>
            </div>    
                
            <div *ngIf="nameTable === 'crawling-web-schedules-detail'">

                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Schedula minuto inizio</mat-label>
                    <mat-select formControlName="selectMinute" panelClass="custom-select-panel">
                        <mat-option *ngFor="let opt of minuteSelectOptions" [value]="opt.value">
                            {{opt.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formData.get('selectMinute')?.invalid && formData.get('selectMinute')?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Schedula ora inizio</mat-label>
                    <mat-select formControlName="selectHour" panelClass="custom-select-panel">
                        <mat-option *ngFor="let opt of hourSelectOptions" [value]="opt.value">
                            {{opt.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formData.get('selectHour')?.invalid && formData.get('selectHour')?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Schedula un giorno</mat-label>
                    <mat-select formControlName="selectDay" panelClass="custom-select-panel" multiple>
                        <mat-option *ngFor="let opt of daySelectOptions" [value]="opt.value">
                            {{opt.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formData.get('selectDay')?.invalid && formData.get('selectDay')?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

            </div>
            
            <!-- Input file nascosto ma accessibile -->
            <input #fileInput type="file" class="sr-only" accept=".txt" (change)="onFileSelected($event)" />
            <ng-container *ngIf="!selectedFile">
                <div *ngIf="data.action === 'add' && nameTable === 'crawling-web'">
                    <mat-checkbox formControlName="sitemap">
                        Sitemap
                    </mat-checkbox>
                </div>
                  
                <div *ngIf="(data.action === 'add' && nameTable === 'crawling-web') ||  (nameTable === 'crawling-web-urls-detail')">
                    <div *ngIf="!isLoading; else loading" class="urls-section">
                        <div formArrayName="extraInputUrlsArray" class="urls-list">
                            <div *ngFor="let extra of extraUrls.controls; let i = index" [formGroupName]="i" class="urls-row">
                                <mat-form-field appearance="fill" class="urls-input">
                                    <mat-label>{{formData.get('sitemap')?.value ? 'SITEMAP' : 'URL'}}</mat-label>
                                    <input matInput formControlName="url" />
                                                        
                                    <mat-error *ngIf="extra.get('url')?.hasError('required') && extraUrls.touched">
                                        Il campo è obbligatorio
                                    </mat-error>
                                </mat-form-field>

                                <div class="urls-remove">
                                    <button *ngIf="extraUrls.length > 1" type="button" mat-icon-button color="warn" class="urls-delete-btn" aria-label="Elimina url" (click)="removeExtraUrl(i)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="data.action === 'add' && !formData.get('sitemap')?.value" class="add-actions">
                        <button class="btn-primary" (click)="addExtraUrl()">
                            <mat-icon>add</mat-icon>
                            Aggiungi URL
                        </button>
                        <button mat-stroked-button class="btn btn-outlined-primary import-button"  (click)="isMassiveImport()" aria-label="Import txt document with many urls" matTooltip="Import txt document with many urls">
                            <mat-icon>upload</mat-icon>
                        </button>
                    
                    </div>
                                   

                    <ng-template #loading>
                        <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
                    </ng-template>
            
                </div>   
            </ng-container>
            <div *ngIf="selectedFile" class="uploaded-file-section">
                <span class="file-label">Documento caricato:</span>
                <mat-chip-set aria-label="File caricato">
                    <mat-chip-row (removed)="removeImportedFile()">
                        {{selectedFile.name}}
                        <button matChipRemove aria-label="Rimuovi file">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                </mat-chip-set>
            </div>
                

    </form>
</div>

<ng-template #deleteTemplate>
    <app-delete-modal [data]="data"></app-delete-modal>
</ng-template>

<div mat-dialog-actions class="button-actions">
    <button mat-stroked-button class=" btn-outlined-primary" (click)="onModalClose()" matTooltip="Annulla" aria-label="Annulla">Annulla</button>
    <button mat-flat-button color="primary" class="btn-primary" [disabled]="formData.invalid && action !== 'delete'" (click)="onModalSave()" [matTooltip]="action === 'delete' ? 'Conferma' : 'Salva'" [attr.aria-label]="action === 'delete' ? 'Conferma' : 'Salva'">
        {{action === 'delete' ? 'Conferma' : 'Salva'}}
    </button>
</div>
